import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { carouselSlides } from "@/mocks/carousel";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = carouselSlides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (index: number) => setActive((index + total) % total);
  const slide = carouselSlides[active];

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="relative h-[380px] w-full md:h-[560px] lg:h-[620px]">
        {carouselSlides.map((item, index) => (
          <Link
            key={item.id}
            to={`/detail/${item.movieId}`}
            className={`absolute inset-0 block transition-opacity duration-700 ${
              index === active ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={item.image}
              alt={`${item.title} 焦点海报`}
              title={`${item.title} - 国产影视作品`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent" />
          </Link>
        ))}

        <div className="pointer-events-none absolute inset-0 flex items-center">
          <div className="mx-auto w-full px-4 md:px-8">
            <div className="pointer-events-auto max-w-2xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-line" />
                {slide.tag}
              </span>
              <h2 className="mt-4 font-heading text-3xl font-bold text-background-50 md:text-5xl">
                {slide.title}
              </h2>
              <p className="mt-3 max-w-xl text-sm text-background-100 md:text-lg">
                {slide.subtitle}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${slide.movieId}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-circle-line text-lg" />
                  查看详情
                </Link>
                <Link
                  to="/category/movie"
                  className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/50 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-compass-3-line text-lg" />
                  浏览全部影视
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-5 right-4 flex items-center gap-3 md:right-8">
          <button
            type="button"
            aria-label="上一张"
            onClick={() => go(active - 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/40 bg-foreground-950/40 text-background-50 transition-colors hover:bg-primary-500"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <button
            type="button"
            aria-label="下一张"
            onClick={() => go(active + 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/40 bg-foreground-950/40 text-background-50 transition-colors hover:bg-primary-500"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>

        <div className="absolute bottom-6 left-4 flex items-center gap-2 md:left-8">
          {carouselSlides.map((item, index) => (
            <button
              key={item.id}
              type="button"
              aria-label={`切换到第 ${index + 1} 张`}
              onClick={() => go(index)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                index === active ? "w-8 bg-accent-500" : "w-3 bg-background-100/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}